module.exports = __webpack_public_path__ + "static/media/asbn-mv.41e1ff2c.jpg";